'use client';

import { ReactNode } from 'react';
import Image from 'next/image';
import { CustomPage } from '../../types/customPage';
import Breadcrumb from '../ui/Breadcrumb';
import { BlogFAQSection } from '../Blog/BlogFAQSection';
import fullLogoBlack from '../../assets/images/full-logo-black.svg';
import styles from '../Blog/BlogPostContent.module.css';

interface CustomPageContentProps {
  page: CustomPage;
  sidebar?: ReactNode;
}

export function CustomPageContent({ page, sidebar }: CustomPageContentProps) {
  return (
    <div className={styles.wrapper}>
      <div className={styles.breadcrumbBar}>
        <div className={styles.container}>
          <Breadcrumb items={[
            { label: 'Home', path: '/' },
            { label: page.title, path: `/${page.slug}` }
          ]} />
        </div>
      </div>

      <div className={styles.container}>
        <article className={styles.article} data-side-cta-anchor>
          {page.featuredImage && (
            <div className={styles.imageWrapper}>
              <Image
                src={page.featuredImage || fullLogoBlack}
                alt={page.featuredImageAlt || page.title}
                fill
                style={{ objectFit: 'contain' }}
                priority
                unoptimized
              />
            </div>
          )}

          <div className={styles.content}>
            <header className={styles.header}>
              <h1 className={styles.title}>{page.title}</h1>

              {page.excerpt && (
                <p className={styles.excerpt}>{page.excerpt}</p>
              )}
            </header>

            <div
              className={styles.body}
              dangerouslySetInnerHTML={{ __html: page.content }}
            />

            {page.faq && page.faq.length > 0 && (
              <BlogFAQSection faq={page.faq} />
            )}
          </div>
        </article>
      </div>

      {sidebar}
    </div>
  );
}
